import { useState, useEffect } from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import DOMPurify from 'dompurify';
import { API_URL } from '../config/api';
import './Contact.css';

const Contact = () => {
    const [content, setContent] = useState({});

    useEffect(() => {
        fetchContent();
    }, []);

    const fetchContent = async () => {
        try {
            const response = await fetch(`${API_URL}/content/contact`);
            const data = await response.json();
            if (data.success) setContent(data.data);
        } catch (error) {
            console.error('Error fetching contact content:', error);
        }
    };

    return (
        <div className="contact-page">
            <section className="page-header">
                <div className="container">
                    <h1 className="page-title">Contacto</h1>
                    <p className="page-subtitle">
                        Estamos aquí para escucharte y resolver tus dudas. Agenda tu cita hoy mismo.
                    </p>
                </div>
            </section>

            <section className="section container">
                <div className="contact-grid" style={{ display: 'block' }}>


                    {/* Contact Info - Now Centered */}
                    <div className="contact-info-wrapper" style={{ margin: '0 auto', maxWidth: '800px', width: '100%' }}>
                        <div className="info-card">
                            <h3>Información de Contacto</h3>
                            <ul className="info-list">
                                <li>
                                    <Phone className="info-icon" />
                                    <div>
                                        <strong>Teléfono</strong>
                                        <p>{content.phone || '+52 55 1234 5678'}</p>
                                    </div>
                                </li>
                                <li>
                                    <Mail className="info-icon" />
                                    <div>
                                        <strong>Correo</strong>
                                        <p>{content.email || 'contacto@geneticaintegral.com'}</p>
                                    </div>
                                </li>
                                <li>
                                    <MapPin className="info-icon" />
                                    <div>
                                        <strong>Ubicación</strong>
                                        <p>{content.address || 'Av. Médica 123, Col. Doctores'}</p>
                                    </div>
                                </li>
                                <li>
                                    <Clock className="info-icon" />
                                    <div>
                                        <strong>Horarios</strong>
                                        <p dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(content.hours || 'Lun - Vie: 9:00 AM - 7:00 PM<br/>Sáb: 9:00 AM - 2:00 PM')
                                        }} />
                                    </div>
                                </li>
                            </ul>

                            <div className="whatsapp-box">
                                <p>¿Prefieres mensajería instantánea?</p>
                                <a
                                    href={`https://wa.me/${(content.whatsapp || '525512345678').replace(/\D/g, '')}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-outline w-100"
                                >
                                    Chat en WhatsApp
                                </a>
                            </div>
                        </div>

                        {/* Map - Dynamic URL */}
                        <div className="map-container">
                            <iframe
                                src={content.map_url || "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.5395970522604!2d-99.15578768509334!3d19.42702058688745!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1ff35f5bd1563%3A0x6c366f0e2de02ff7!2sEl%20Angel%20of%20Independence!5e0!3m2!1sen!2smx!4v1647895000000!5m2!1sen!2smx"}
                                width="100%"
                                height="300"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                title="Google Maps"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;
